import React, { useState } from 'react';
import '../styles/JoinPromptDialog.css'; // Optional: Für eigenes Styling

function JoinPromptDialog({ lobbyCode, onSubmit, onClose, error, forcePassword = false }) {
    const [name, setName] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!name.trim()) return;
        onSubmit({ name: name.trim(), password });
    };

    return (
        <div className="container">
            <div className="dialog-box">
                <h2>Lobby beitreten</h2>
                <p>Lobby-Code: <strong>{lobbyCode}</strong></p>

                {error && <p className="error">{error}</p>}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="name">Dein Name:</label>
                        <input
                            type="text"
                            id="name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            maxLength={20}
                            required
                        />
                    </div>

                    {forcePassword && (
                        <div className="form-group">
                            <label htmlFor="password">Passwort:</label>
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>
                    )}

                    <div className="button-group">
                        <button type="submit" className="button button-primary">
                            <i className="fas fa-sign-in-alt"></i> Beitreten
                        </button>
                        <button type="button" className="button button-secondary" onClick={onClose}>
                            <i className="fas fa-times"></i> Abbrechen
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default JoinPromptDialog;
